<template>
    <div>
        <el-row class="">
            <el-col>
                <div class="table-grd">
                    <div class="header">
                        <h1>{{ $t('Activity Logs') }}</h1>
                        <ul class="icon-list">
                            <li><a href="javascript:void(0)" @click="exportFile" :title="$t('Export')"><i class="icon-excel"></i></a></li>
                            <li><a href="javascript:void(0)" :title="$t('Search')" v-collapse-toggle="'toggle_first'"><i class="icon-advance-search"></i></a></li>
                        </ul>
                    </div>
                    <v-collapse-group ref="group1">
                        <v-collapse-wrapper ref="toggle_second">
                            <div class="my-content table-desc">
                                <v-collapse-wrapper ref="toggle_first" class="search-data">
                                    <div class="my-content" v-collapse-content>
                                        <el-form :model="filterData" ref="filterData" :inline="true">
                                            <div class="top-dev">
                                                <el-col :xs="24" :sm="8" :md="6" :lg="4" :xl="4">
                                                    <el-form-item prop="alphaColumn" class="alphaColumn">
                                                        <el-select v-model="filterData.alphaColumn" placeholder="Columns" @change="alphaColumnChange">
                                                            <el-option v-for="(item) in alphaColumns" :label="item.label" :value="item.value" :key="item.value"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="24" :sm="16" :md="18" :lg="20" :xl="20">
                                                    <el-form-item prop="alpha" class="name-list">
                                                        <span v-for="a in alphabet" @click="alpha(a)" :class="{ active: filterData.alpha == a }" :key="a">{{a}}</span>
                                                    </el-form-item>
                                                </el-col>
                                            </div>
                                            <div class="bottom-dev">
                                                <el-col :xs="24" :sm="8" :md="6" :lg="5" :xl="3">
                                                    <el-form-item class="all-select">
                                                        <el-select v-model="selectedColumns" multiple placeholder="Columns" collapse-tags>
                                                            <el-option v-for="(item) in column_name" :label="item.label" :value="item.value" :key="item.value"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="24" :sm="8" :md="4" :lg="4" :xl="3">
                                                    <el-form-item prop="display_name">
                                                        <el-input v-model="filterData.display_name" :placeholder="$t('Display Name')" @keyup.enter.native="handleCurrentChange"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="24" :sm="8" :md="4" :lg="4" :xl="3">
                                                    <el-form-item prop="log_name">
                                                        <el-input v-model="filterData.log_name" :placeholder="$t('Changed Data')" @keyup.enter.native="handleCurrentChange"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="24" :sm="8" :md="4" :lg="4" :xl="3">
                                                    <el-form-item prop="customModelName">
                                                        <el-input v-model="filterData.customModelName" :placeholder="$t('On Module')" @keyup.enter.native="handleCurrentChange"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="24" :sm="8" :md="4" :lg="4" :xl="3">
                                                    <el-form-item prop="description">
                                                        <el-input v-model="filterData.description" :placeholder="$t('Action')" @keyup.enter.native="handleCurrentChange"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <div class="el-form-item">
                                                    <el-button type="primary" icon="el-icon-search" @click="handleCurrentChange">{{
                                                        $t('Search') }}</el-button>
                                                    <el-button type="cancel" @click="resetForm('filterData')">{{
                                                        $t('Reset') }}</el-button>
                                                </div>
                                            </div>
                                        </el-form>
                                    </div>
                                </v-collapse-wrapper>
                                <el-dialog :title="$t('Activity Logs')" :visible.sync="activityDialog">
                                    <el-form>
                                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                            <pre class="json-div">{{ currentLog }}</pre>
                                        </el-col>
                                        <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
                                    </el-form>
                                </el-dialog>
                                <el-table class="logTableData"  ef="multipleTable" :data="logs.data" @sort-change="handleSortChange" fit highlight-current-row key='aTable'>
                                    <el-table-column :label="$t('No.')" type="index" :index="indexMethod" width="150" fixed></el-table-column>
                                    <el-table-column   :label="$t('Changed By')" sortable="custom" prop="display_name" v-if="selectedColumns.includes('display_name')" width="200">
                                    </el-table-column>
                                    <el-table-column show-overflow-tooltip :label="$t('Changed Data')" sortable="custom" prop="log_name" v-if="selectedColumns.includes('log_name')" width="850">
                                        <template slot-scope="scope">
                                            <a href="javascript:void(0)" @click="showFullLog(scope.row)">{{ scope.row.properties }}</a>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('On Module')" sortable="custom" class="test354" prop="customModelName" v-if="selectedColumns.includes('customModelName')" width="230">
                                    </el-table-column>
                                    <el-table-column :label="$t('Action')" sortable="custom" prop="description" v-if="selectedColumns.includes('description')" width="150">
                                        <template slot-scope="scope">
                                            <span v-ucfirst="scope.row.description"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Created at')" sortable="custom" prop="created_at" v-if="selectedColumns.includes('created_at')" width="250">
                                        <template slot-scope="scope">
                                            <span v-date-time-format="scope.row.created_at"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column min-width="10"></el-table-column>
                                </el-table>
                                <el-pagination v-if="logs.meta.total" background @size-change="handleSizeChange" @current-change="filterParams.page = filterData.page;getLogs()" :current-page.sync="filterData.page" :page-sizes="[6, 12, 24, 66, 111]" :page-size="filterData.pageLength" layout="sizes, slot, ->, prev, pager, next" :total="logs.meta.total">
                                    <template>
                                        <span class="page-no">{{ $t('Showing out of records',{'0':
                                            logs.data.length, '1': logs.meta.total}) }}</span>
                                    </template>
                                </el-pagination>
                            </div>
                        </v-collapse-wrapper>
                    </v-collapse-group>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                filterData: {
                    page: 1,
                    pageLength: process.env.KIPAKI_pageLength,
                    sortBy: "id",
                    order: "desc",
                    alphaColumn: null,
                    alpha: null
                },
                logs: {
                    meta: {},
                    data: []
                },
                column_name: [{
                        value: "display_name",
                        label: this.$t('Changed By')
                    },
                    {
                        value: "log_name",
                        label: this.$t('Changed Data')
                    },
                    {
                        value: "customModelName",
                        label: this.$t('On Module')
                    },
                    {
                        value: 'description',
                        label: this.$t('Action')
                    },
                    {
                        value: 'created_at',
                        label: this.$t('Created at')
                    }
                ],
                selectedColumns: [],
                alphabet: 'A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z'.split(','),
                downloadLoading: false,
                activityDialog: false,
                currentLog: null,
                filterParams: {}
            };
        },
        computed: {
            alphaColumns() {
                return this.column_name.filter(c => !['log_name','display_name','created_at'].includes(c.value));
            }
        },
        mounted() {
            this.filterParams = Object.assign({}, this.filterData);
            this.selectedColumns = this.column_name.map(a => a.value);
            this.getLogs();
        },
        methods: {
            getLogs() {
                request({
                    url: "activity-logs",
                    method: "get",
                    params: this.filterParams
                }).then(response => {
                    this.logs = response.data;
                    this.logs.data = this.logs.data.map(v => {
                        this.$set(v, 'edit', false)
                        return v
                    });
                    setTimeout(() => {
                        $('table .el-tooltip').removeClass('el-tooltip');
                    });
                });
            },
            showFullLog(row) {
                this.activityDialog = true;
                this.currentLog = JSON.stringify(row.properties, null, 4);
            },
            alphaColumnChange(val) {
                this.filterParams.alphaColumn = val;
                if (this.filterData.alpha) {
                    this.getLogs();
                }
            },
            handleCurrentChange(event) {
                this.filterData.page = 1;
                this.filterParams = Object.assign({}, this.filterData);
                this.getLogs(this.filterData.current_page);
            },
            handleSizeChange(event) {
                this.filterData.pageLength = event;
                this.filterParams.pageLength = event;
                this.getLogs();
            },
            handleSortChange(event) {
                this.filterParams.sortBy = event.prop;
                if (event.order === "ascending") this.filterParams.order = "asc";
                else if (event.order === "descending") this.filterParams.order = "desc";
                else {
                    this.filterParams.sortBy = "id";
                    this.filterParams.order = "desc";
                }
                this.getLogs();
            },
            indexMethod(index) {
                return (
                    index +
                    this.filterData.pageLength * this.filterData.page -
                    this.filterData.pageLength +
                    1
                );
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.filterParams = Object.assign({}, this.filterData);
                this.getLogs();
            },
            alpha(a) {
                this.filterParams.alpha = a;
                this.filterData.alpha = a;
                if (this.filterData.alphaColumn)
                    this.getLogs();
            },
            exportFile() {
                this.downloadLoading = true
                import('@/vendor/Export2Excel').then(excel => {
                    const tHeader = this.column_name.filter(a => {
                        return this.selectedColumns.includes(a.value)
                    }).map(b => b.label);
                    const data = this.formatJson(this.selectedColumns, this.logs.data)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: this.$t('Activity Logs')
                    })
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => {
                    return v[j]
                }))
            }
        }
    };

</script>
<style scoped>
    .json-div {
        color: var(--base-theme-color);
        overflow-x: auto;
    }
    .el-table__body td {
        z-index: 4; 
    }

</style>



// WEBPACK FOOTER //
// src/components/Layout/ActivityLogs/ActivityLogs.vue